export class Helper {
  /**
   * Check if the given value is defined
   *
   * @param v value under test
   * @returns if the value is defined
   */
  public static isDefined(v: unknown): boolean {
    return v !== undefined && v !== null;
  }

  /**
   * Check if the array exists and is not empty
   *
   * @param v array to test
   * @returns if not empty
   */
  public static notEmpty(v: ArrayLike<unknown>): boolean {
    return !!v && v.length > 0;
  }

  /**
   * Generic comparison function between strings or numbers
   *
   * @param a first value
   * @param b second value
   * @param isAsc compare ascending
   * @returns comparison result
   */
  public static compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * Calculate the number of days between two dates
   *
   * @param a date in ms since epoch
   * @param b date in ms since epoch
   * @returns days between
   */
  public static daysBetween(a: number, b: number): number {
    const ONE_DAY = 1000 * 60 * 60 * 24;
    const difference = b - a;
    return Math.floor(difference / ONE_DAY);
  }
}